// @ts-expect-error TODO: type-react-components
import { genericValidationFn } from '@checkout/react-components';

import { logger } from '@/lib/logger';
import { getGlobals } from '@/lib/globals';
import { appStore } from '@/store';
import { getExperiment } from '@/lib/experiments';
import { iwcEmailLookup } from './iwcEmailLookup';
import { handleSignupSuppress } from './handleSignupSuppress';
import {
  logEmailLookupCompleted,
  logEmailLookupStart,
} from './fpti/xobuyerLookupFpti';
import { features } from '@/lib/features';
import { isExistingAccountEmailLookupEligible } from './isExistingAccountEmailLookupEligible';

export const validateEmail = (email: string): boolean => {
  const props = { required: true, type: 'email' };
  const { isValid } = genericValidationFn(email, { props });
  return isValid;
};

export const shouldUseIWC = (): boolean => {
  const { ui } = appStore.getState();
  if (ui.isOpenBankingReturn) {
    return false;
  }

  // We should let email lookup run for Google Pay Later use case
  // as it needs to detect existing PayPal accounts and show the login link in the Email component.
  // We do not need to run email lookup if the shouldShowOTP experiment is not enabled.
  if (
    !getExperiment('shouldShowOTP') &&
    !features.isActive('isGooglePayLaterOnly') &&
    !isExistingAccountEmailLookupEligible()
  ) {
    return false;
  }

  // Even if in exp we can not use IWC if context is missing
  const context = getGlobals().deferredQueryData.otpLoginContext.context;

  if (!context) {
    logger.warn('MISSING_IWC_CONTEXT', {
      message:
        'IWC email lookup was attempted, but IWC context is missing. Falling back to xobuyer lookup.',
    });

    return false;
  }

  return true;
};

export const emailLookup = async (email: string): Promise<void> => {
  const { setLastEmailLookup, setIsExistingAccount } =
    appStore.getActions().api;
  const { api } = appStore.getState();

  if (api.lastEmailLookup !== email && validateEmail(email) && shouldUseIWC()) {
    logEmailLookupStart();
    setLastEmailLookup(email);

    const isExistingAccount = await iwcEmailLookup(email);

    // Handle race conditions where user changed email before response
    const { form } = appStore.getState();
    if (email === form.email.value) {
      setIsExistingAccount(isExistingAccount);
      handleSignupSuppress(isExistingAccount);

      logEmailLookupCompleted(isExistingAccount);
    }
  }
};
